
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menus/[...params]",
      function () {
        return require("private-next-pages/menus/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menus/[...params]"])
      });
    }
  